import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
// import { User } from 'src/app/core/models/auth.models';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-add-tp-service',
  templateUrl: './add-tp-service.component.html',
  styleUrls: ['./add-tp-service.component.scss']
})
export class AddTpServiceComponent implements OnInit {


  breadCrumbItems: Array<{}>;
  TPForm: FormGroup;
  submitted = false;
  isLoading: boolean;
  keyword = 'UserName';
  currentUser: any;
  serviceList: any;
  subserviceList: any;
  isShowDistrict: boolean = true;
  isShowTaluka: boolean = false;
  isShowVillage: boolean = false;
  isShowTP: boolean = false;
  districtList: any;
  talukaList: any;
  editTP:any
  userId:any
  villageList: any;
  UserSubscriptionMainID: any;
  tpData: any;
  Type: any;
  tpID:any;
  newdate: string;
  originalAuctionValues: any;
  updateButtonDisabled: boolean = false;
  updatedData: any;
  constructor(private fb: FormBuilder,
    private gs: GeneralService,
    private route: ActivatedRoute,
    private router: Router,
    private datepipe: DatePipe) { 
      this.Type = this.route.snapshot.params.type;
      let a = this.router.getCurrentNavigation().extras
      localStorage.setItem('EditTP','false')
      if(a){
        if(a.state){
          // this.userId = a.state.Uid;
          // localStorage.setItem('Uid',this.userId)
          
          if(a.state.EditTP === true){
            this.userId = a.state.Userid;
          localStorage.setItem('Uid',this.userId)
            this.editTP = a.state.EditTP
            this.tpID =  a.state.id
            console.log("userid",this.userId)
            console.log("Rowid",this.tpID)
            console.log("EditTp",this.editTP)
            localStorage.setItem('EditTP',this.editTP)
            localStorage.setItem('Rowid',this.tpID)
          }
          else{
            this.userId = a.state.Uid;
          localStorage.setItem('Uid',this.userId)
          console.log("userid",this.userId)
            let state = localStorage.getItem('EditTP')
            this.editTP = state == 'true'? true:false;
            this.editTP = a.state.Editproperty
          }
        }
        
      }
      if(localStorage.getItem('Uid')){
        this.userId = localStorage.getItem('Uid')
      }
      if(this.editTP === true){
        this.Type = 'edit'
            this.breadCrumbItems = [
                { label: 'TP List', path: '/users/view-tp-list' },
                { label: 'Update TP Service', path: '/', active: true },
              ];
      }else{
         this.breadCrumbItems = [
              { label: 'TP List', path: '/users/view-tp-list' },
              { label: 'Add TP Service', path: '/', active: true },
            ];
      }
    }

  async ngOnInit() {
    this.newdate = new Date().toISOString().substr(0, 10);
    this.getservice();
    this.currentUser = this.gs.getcurrentUser();
   
    this.TPForm = this.fb.group({
      service: new FormControl(null),
      serviceID: new FormControl(null, Validators.required),
      ServiceName: new FormControl(null),
      Service_Sub_Type_ID: new FormControl(null),
      Service_Sub_Type: new FormControl(null, Validators.required),
      SubType_Name: new FormControl(null),
      DistrictID: new FormControl(null),
      DistrictName: new FormControl(null),
      TalukaID: new FormControl(null),
      TalukaName:new FormControl(null),
      isActive: new FormControl(null),
      VillageID: new FormControl(null),
      VillageName:new FormControl(null),
      UserSubscriptionMainID: new FormControl(null),
      startDate: new FormControl(null, [Validators.required,Validators.pattern('\\d{4}-\\d{2}-\\d{2}')]),
      endDate: new FormControl(null, [Validators.required,Validators.pattern('\\d{4}-\\d{2}-\\d{2}')]),
      UserID: new FormControl(null),
      TPNo: new FormControl(null),
      dist: new FormControl(null),
      tal: new FormControl(null),
      vill: new FormControl(null),
    },
    { validators: this.startDateBeforeEndDateValidator }
  );
    if(this.Type === 'edit'){
      await this.getServiceDetails()
      this.updateButtonDisabled = true
      this.TPForm.controls.serviceID.disable();
      this.TPForm.controls.Service_Sub_Type.disable();
    }
   
   
  }
  dublicateDat(){

 this.TPForm.valueChanges.subscribe((changedValues) => {
      const isFormModified = this.areObjectsEqual( this.TPForm.value, this.updatedData);
      console.log('changesvalue',changedValues)
      console.log('dbcndsbcsb',this.updatedData)
        this.updateButtonDisabled = !isFormModified;
    });
  }

  areObjectsEqual(obj1, obj2) {
  
    return (
      obj1.DistrictID !== obj2.DistrictID ||
      obj1.TalukaID !== obj2.TalukaID ||
      obj1.VillageID !== obj2.VillageID ||
      obj1.startDate !== obj2.startDate ||
      obj1.endDate !== obj2.endDate ||
      obj1.TPNo !== obj2.TPNo
    )
  }
  onSubmit(){
    this.submitted = true;
    this.TPForm.controls.UserID.setValue(this.userId)
    console.log('TP FORM VALUE',this.TPForm.value)
    if(this.TPForm.valid){
      this.isLoading = true;
      delete this.TPForm.value.dist
    delete this.TPForm.value.serviceID
      delete this.TPForm.value.tal
      delete this.TPForm.value.Service_Sub_Type

      delete this.TPForm.value.vill
      let data = this.TPForm.value
      var title;
      if(this.Type ==='edit'){
        console.log("TPID",this.tpID)
        data['UserSubscriptionMainID'] = this.tpID
        // this.TPForm.controls.UserSubscriptionMainID.setValue(this.tpID)
        title = 'TP Service Updated'
      }else{
        // delete data['UserSubscriptionMainID']
        title = 'TP Service Added'
      }
      this.gs.addTP(data).subscribe((res:any)=>{
        this.isLoading = false;
        this.submitted = false
        if(res.status === 500){
          Swal.fire({
            position: 'top-end',
            type: 'error',
            title: 'Internal Server Error',
            showConfirmButton: false,
            timer: 1500
          });
          this.router.navigate(['/users/view-tp-list'])
        }
        if(res.status === 400){
          Swal.fire({
            position: 'top-end',
            type: 'info',
            title: res.Message,
            showConfirmButton: false,
            timer: 1500
          });
          this.router.navigate(['/users/view-tp-list'])
        }else{
          Swal.fire({
            position: 'top-end',
            type: 'success',
            title: res.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.router.navigate(['/users/view-tp-list'])
        }
      })
   
    }

  }
  getSubServices(id) {
    this.isLoading = true;
    this.gs.subservice(id)
    .subscribe((res) => {
      this.isLoading = false;
      this.subserviceList = res.data;
      // if(this.Type ==='edit') {
      //   this.ChangeSubService(this.tpData.data[0].Service_Sub_Type_ID)
      // }
    },(error) => {                              //Error callback
      this.isLoading = false;
      Swal.fire({
        title: error.status,
        text: "Internal Server Error",
        type: "error",
      });
      //throw error;   //You can also throw the error to a global error handler
    });
  }
  async getServiceDetails() {
    this.isLoading = true;
    await this.gs.FetchTP(this.tpID,this.userId)
    .subscribe((res) => {
      this.isLoading = false;
      this.tpData = res
      console.log("TPDARA",this.tpData)
      this.getSubServices(this.tpData.data[0].ServiceID);
      this.ChangeSubService(this.tpData.data[0])
      this.ChangeTaluka(this.tpData.data[0])
      this.TPForm.get('isActive').setValidators([Validators.required]);
      this.TPForm.get('isActive').updateValueAndValidity();
      this.tpData.data[0].startDate = this.datepipe.transform(this.tpData.data[0].startDate,'yyyy-MM-dd');
      this.tpData.data[0].endDate = this.datepipe.transform(this.tpData.data[0].endDate,'yyyy-MM-dd');
      this.TPForm.controls.serviceID.setValue(this.tpData.data[0].ServiceName);
      this.TPForm.controls.ServiceName.setValue(this.tpData.data[0].ServiceName)
      this.TPForm.controls.service.setValue(this.tpData.data[0].ServiceID)
      this.TPForm.controls.Service_Sub_Type_ID.setValue(this.tpData.data[0].Service_Sub_Type_ID);
      this.TPForm.controls.Service_Sub_Type.setValue(this.tpData.data[0].SubType_Name);
      this.TPForm.controls.DistrictID.setValue(this.tpData.data[0].DistrictID);
      this.TPForm.controls.dist.setValue(this.tpData.data[0].DistrictName);
      this.TPForm.controls.vill.setValue(this.tpData.data[0].VillageName);
      this.TPForm.controls.tal.setValue(this.tpData.data[0].TalukaName);
      this.TPForm.controls.DistrictName.setValue(this.tpData.data[0].DistrictName);
      this.TPForm.controls.TalukaID.setValue(this.tpData.data[0].TalukaID);
      this.TPForm.controls.VillageID.setValue(this.tpData.data[0].VillageID);
      this.TPForm.controls.VillageName.setValue(this.tpData.data[0].VillageName);
      this.TPForm.controls.startDate.setValue(this.tpData.data[0].startDate);
      this.TPForm.controls.isActive.setValue(`${this.tpData.data[0].isActive}`);
      this.TPForm.controls.endDate.setValue(this.tpData.data[0].endDate);
      this.TPForm.controls.TPNo.setValue(this.tpData.data[0].TPNo);
      this.updatedData = this.TPForm.value
      this.dublicateDat()
     
      console.log('TP FORM',this.TPForm.value)
      console.log('TP updatedData',this.updatedData)


    },(error) => {                              //Error callback
      this.isLoading = false;
      Swal.fire({
        title: error.status,
        text: "Internal Server Error",
        type: "error",
      });
      //throw error;   //You can also throw the error to a global error handler
    });
  }
  ChangeService(item) {
    console.log('Sevice',item)
    if(this.Type  === 'edit'){
      this.getDistrict()
      // this.TPForm.controls.tal.setValue(null);
      // this.TPForm.controls.vill.setValue(null);
      // this.TPForm.controls.TPNo.setValue(null);
    }else{

      this.TPForm.controls.Service_Sub_Type.setValue(null);
      this.TPForm.controls.dist.setValue(null);
      this.TPForm.controls.tal.setValue(null);
      this.TPForm.controls.vill.setValue(null);
      this.TPForm.controls.TPNo.setValue(null);
    }
    this.subserviceList = [];
    this.districtList = [];
    this.talukaList = []; 
    this.villageList = [];
    if(item.ServiceID) {
      this.TPForm.controls.ServiceName.setValue(item.ServiceName)
      this.TPForm.controls.service.setValue(item.ServiceID)
      this.isLoading = true;
      this.gs.subservice(item.ServiceID)
    .subscribe((res) => {
      this.isLoading = false;
      this.subserviceList = res.data;
    },(error) => {                              //Error callback
      this.isLoading = false;
      Swal.fire({
        title: error.status,
        text: "Internal Server Error",
        type: "error",
      });
      //throw error;   //You can also throw the error to a global error handler
    });
    }
  }
  getservice() {
    this.isLoading = true;
    this.gs.service()
    .subscribe((res) => {
      this.isLoading = false;
      this.serviceList = res.data;
    },(error) => {                              //Error callback
      this.isLoading = false;
      Swal.fire({
        title: error.status,
        text: "Internal Server Error",
        type: "error",
      });
      //throw error;   //You can also throw the error to a global error handler
    });
  }
  ChangeDistrict(item:any) {
    console.log("DistrcitId",item)
    if(item === undefined){
      this.talukaList = [];
      this.villageList = [];
      this.TPForm.controls.tal.setValue(null);
       this.TPForm.controls.vill.setValue(null);
       this.dublicateDat()
    }
    let id
    if(item.DistrictID){
      id = item.DistrictID
      this.TPForm.controls.DistrictID.setValue(item.DistrictID);
      this.TPForm.controls.DistrictName.setValue(item.DistrictName);
    }
    if(item.Districtid){
      id = item.Districtid
      this.TPForm.controls.DistrictID.setValue(item.Districtid);
      this.TPForm.controls.DistrictName.setValue(item.districtname);
    }
    this.TPForm.controls.TalukaID.setValue(null);
    this.TPForm.controls.VillageID.setValue(null);
    this.TPForm.controls.tal.setValue(null);
    this.TPForm.controls.vill.setValue(null);
    this.TPForm.controls.TPNo.setValue(null);
    this.talukaList = []; 
    this.villageList = [];

    if(id) {
      this.isLoading = true;
      this.gs.getTaluka(id)
        .subscribe((res:any) => {
          this.isLoading = false;
          this.talukaList = res.data;
      },(error) => {                              //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      });
    }

   
  }
  ChangeTaluka (item:any) {
    console.log('Taluka',item)
   
    if(item === undefined){
      this.TPForm.controls.vill.setValue(null)
      this.villageList = [];
    }
    this.TPForm.controls.VillageID.setValue(null);
    this.TPForm.controls.vill.setValue(null)
    this.TPForm.controls.TPNo.setValue(null);
    this.TPForm.controls.TalukaName.setValue(item.TalukaName);
    this.TPForm.controls.TalukaID.setValue(item.TalukaID);
    this.villageList = [];
    if(item.TalukaID) {
      this.isLoading = true;
      this.gs.getVillage(item.TalukaID)
      .subscribe((res:any) => {
        console.log('taluka',res)
        this.isLoading = false;
        this.villageList = res.data;
      },(error) => {                              //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      });
    }
    if(this.Type === 'edit'){
      this.dublicateDat()
    }


  }
  changeVillage(item:any) {
    console.log('changeVillage',item)
    this.TPForm.controls.TPNo.setValue(null);
    if(item.VillageID){
      this.TPForm.controls.VillageID.setValue(item.VillageID);
      this.TPForm.controls.VillageName.setValue(item.VillageName);
    }
    if(item.id){
      this.TPForm.controls.VillageID.setValue(item.id);
      this.TPForm.controls.VillageName.setValue(item.villagename);
    }
    if(this.Type === 'edit'){
      this.dublicateDat()
    }

  }
  ChangeSubService(item) {
    console.log('ChangeSubService',item)

    this.TPForm.controls.SubType_Name.setValue(item.SubType_Name)
    this.TPForm.controls.Service_Sub_Type_ID.setValue(item.Service_Sub_Type_ID)
    if (item.Service_Sub_Type_ID === "28" || item.Service_Sub_Type_ID === "24") {
      this.TPForm.get('dist').setValidators([Validators.required]);
      this.TPForm.get('tal').clearValidators();
      this.TPForm.get('vill').clearValidators();
      this.TPForm.get('TPNo').clearValidators();
      this.TPForm.get('dist').updateValueAndValidity();
      this.TPForm.get('tal').updateValueAndValidity();
      this.TPForm.get('vill').updateValueAndValidity();
      this.TPForm.get('TPNo').updateValueAndValidity();
      this.TPForm.controls.TalukaID.setValue(null);
      this.TPForm.controls.VillageID.setValue(null);
      this.TPForm.controls.TPNo.setValue(null);
      this.talukaList = []; 
      this.villageList = [];
      this.isShowDistrict = true;
      this.isShowTaluka = false;
      this.isShowVillage = false;
      this.isShowTP = false;
    } else if (item.Service_Sub_Type_ID === "29" || item.Service_Sub_Type_ID === "25") {
      this.TPForm.get('dist').setValidators([Validators.required]);
      this.TPForm.get('tal').setValidators([Validators.required]);
      this.TPForm.get('vill').clearValidators();
      this.TPForm.get('TPNo').clearValidators();
      this.TPForm.get('dist').updateValueAndValidity();
      this.TPForm.get('tal').updateValueAndValidity();
      this.TPForm.get('vill').updateValueAndValidity();
      this.TPForm.get('TPNo').updateValueAndValidity();
      this.TPForm.controls.VillageID.setValue(null);
      this.TPForm.controls.TPNo.setValue(null);
      if(this.TPForm.controls.DistrictID.value != null) {
        this.getTaluka(this.TPForm.controls.DistrictID.value);
      }
      this.villageList = [];
      this.isShowDistrict = true;
      this.isShowTaluka = true;
      this.isShowVillage = false;
      this.isShowTP = false;
    } else if (item.Service_Sub_Type_ID === "30" || item.Service_Sub_Type_ID === "26") {
      this.TPForm.get('dist').setValidators([Validators.required]);
      this.TPForm.get('tal').setValidators([Validators.required]);
      this.TPForm.get('vill').setValidators([Validators.required]);
      this.TPForm.get('TPNo').clearValidators();
      this.TPForm.get('dist').updateValueAndValidity();
      this.TPForm.get('tal').updateValueAndValidity();
      this.TPForm.get('vill').updateValueAndValidity();
      this.TPForm.get('TPNo').updateValueAndValidity();
      this.TPForm.controls.TPNo.setValue(null);
      if(this.TPForm.controls.DistrictID.value != null) {
        this.getTaluka(this.TPForm.controls.DistrictID.value);
      }
      if(this.TPForm.controls.TalukaID.value != null) {
        this.getVillage(this.TPForm.controls.TalukaID.value);
      }
      this.isShowDistrict = true;
      this.isShowTaluka = true;
      this.isShowVillage = true;
      this.isShowTP = false;
    } else if (item.Service_Sub_Type_ID === "31" || item.Service_Sub_Type_ID === "27") {
      this.TPForm.get('dist').setValidators([Validators.required]);
      this.TPForm.get('tal').setValidators([Validators.required]);
      this.TPForm.get('vill').setValidators([Validators.required]);
      this.TPForm.get('TPNo').setValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9\/-]*$')]);
      this.TPForm.get('dist').updateValueAndValidity();
      this.TPForm.get('tal').updateValueAndValidity();
      this.TPForm.get('vill').updateValueAndValidity();
      this.TPForm.get('TPNo').updateValueAndValidity();
      if(this.TPForm.controls.DistrictID.value != null) {
        this.getTaluka(this.TPForm.controls.DistrictID.value);
      }
      if(this.TPForm.controls.TalukaID.value != null) {
        this.getVillage(this.TPForm.controls.TalukaID.value);
      }
      this.isShowDistrict = true;
      this.isShowTaluka = true;
      this.isShowVillage = true;
      this.isShowTP = true;
    } 
    if(item.Service_Sub_Type_ID) {
      this.getDistrict();
    }
    
  }
  datechange() {
    this.TPForm.controls['endDate'].setValue(null);
    var date = new Date(this.TPForm.controls.startDate.value);
    this.TPForm.controls.endDate.setValue(this.add_years(date, 1).toISOString().substr(0, 10));
  }
  add_years(dt,n) 
  {
    return new Date(dt.setFullYear(dt.getFullYear() + n));      
  }
  get f() {
    return this.TPForm.controls;
  }
  getDistrict() {
    this.isLoading = true;
    this.gs.UserDistrictWise(this.userId).subscribe((res:any) => {
      this.isLoading = false;
      this.districtList = res.data;
      if(this.Type === 'edit' && this.tpData.data[0].TalukaID != null) {
        this.getTaluka(this.tpData.data[0].DistrictID)
      }
    },(error) => {                              //Error callback
      this.isLoading = false;
      Swal.fire({
        title: error.status,
        text: "Internal Server Error",
        type: "error",
      });
      //throw error;   //You can also throw the error to a global error handler
    });
  }
  getTaluka(DistrictID) {
    this.isLoading = true;
    this.gs.getTaluka(DistrictID)
    .subscribe((res:any) => {
      this.isLoading = false;
      this.talukaList = res.data;
      if(this.Type === 'edit' && this.tpData.data[0].VillageID != null) {
        this.getVillage(this.tpData.data[0].TalukaID)
      }
    },(error) => {                              //Error callback
      this.isLoading = false;
      Swal.fire({
        title: error.status,
        text: "Internal Server Error",
        type: "error",
      });
      //throw error;   //You can also throw the error to a global error handler
    });
  }
  getVillage(TalukaID) {
    this.isLoading = true;
    this.gs.getVillage(TalukaID)
    .subscribe((res:any) => {
      this.isLoading = false;
      this.villageList = res.data;
    },(error) => {                              //Error callback
      this.isLoading = false;
      Swal.fire({
        title: error.status,
        text: "Internal Server Error",
        type: "error",
      });
      //throw error;   //You can also throw the error to a global error handler
    });
  }
  startDateBeforeEndDateValidator(control: AbstractControl): ValidationErrors | null {
    const startDate = control.get('startDate').value;
    const endDate = control.get('endDate').value;

    if (startDate && endDate && startDate >= endDate) {
      return { startDateAfterEndDate: true };
    }
    return null;
  }
}
